import { render, staticRenderFns } from "./reservationList.vue?vue&type=template&id=567708c6&scoped=true"
import script from "./reservationList.vue?vue&type=script&lang=js"
export * from "./reservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567708c6",
  null
  
)

export default component.exports